/** Mirrors the backend's checks on an uploaded payment proof. */
export const PROOF_ACCEPT = 'image/png,image/jpeg,image/webp';
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
const MAX_BYTES = 5 * 1024 * 1024;
/** The most proof images one settlement may hold (backend MaxSettlementProofs). */
export const MAX_PROOFS = 10;

/**
 * Adds the files picked in a file input to `current`, refusing any that are
 * the wrong type or too large, and stopping at `room` files in total. Returns
 * the new list and an error to show, if any file was left out.
 */
export function addProofFiles(input: HTMLInputElement, current: File[], room = MAX_PROOFS): { files: File[]; error: string } {
  const picked = Array.from(input.files ?? []);
  input.value = '';
  const files = [...current];
  let error = '';
  for (const file of picked) {
    if (!ALLOWED_TYPES.includes(file.type)) {
      error = `${file.name}: proof image must be png, jpeg, or webp.`;
    } else if (file.size > MAX_BYTES) {
      error = `${file.name}: proof image exceeds 5MB.`;
    } else if (files.length >= room) {
      error = `At most ${room} proof image${room === 1 ? '' : 's'} can be attached here.`;
    } else {
      files.push(file);
    }
  }
  return { files, error };
}
